import validObj from '@/helpers/object'

window.displayMessage = (type, title, text) => {
  objSwal[type].title = title
  objSwal[type].text = text

  return Swal.fire(objSwal[type]).then((res) => {
    objSwal[type].title = null
    objSwal[type].text = null
    return res
  })
}

window.getErrors = (error) => {
  let message

  if (validObj(error, ['response', 'data', 'message', 'errors'])) {
    message = JSON.stringify(error.response.data.message.errors)
  } else if (validObj(error, ['response', 'data', 'error', 'message'])) {
    message = JSON.stringify(error.response.data.error.message)
  } else if (validObj(error, ['response', 'data', 'message'])) {
    message = error.response.data.message
  } else if (validObj(error, ['response', 'data'])) {
    message = error.response.data
  } else if (validObj(error, ['response'])) {
    message = error.response
  }  else if (validObj(error, ['message'])) {
    message = error.message
  } else {
    message = error
  }


  if (typeof message === 'object') {
    message = JSON.stringify(message)
  }

  return {
    message,
    status: error.status || 400
  }
}

window.validarCPF = (strCPF) => {
  strCPF = strCPF.replace(/[.|-]/g, '')
  var Soma
  var Resto
  Soma = 0
  if (strCPF == "00000000000") return false

  for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i)
  Resto = (Soma * 10) % 11

  if ((Resto == 10) || (Resto == 11))  Resto = 0
  if (Resto != parseInt(strCPF.substring(9, 10)) ) return false

  Soma = 0
  for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i)
  Resto = (Soma * 10) % 11

  if ((Resto == 10) || (Resto == 11))  Resto = 0
  if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false
  return true
}

window.limparString = (string) => {
  if (string != null) {
    return string.replace(/[-,' ',(,),_]/g, '')
  } else {
    return string
  }

}

window.removerAcentos = (string) => {
  return string.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
}

window.base64toBlob = (base64Data, contentType = '') => {
  const sliceSize = 1024
  const byteCharacters = atob(base64Data)
  const bytesLength = byteCharacters.length
  const slicesCount = Math.ceil(bytesLength / sliceSize)
  const byteArrays = new Array(slicesCount)

  for (let sliceIndex = 0; sliceIndex < slicesCount; sliceIndex += 1) {
    const begin = sliceIndex * sliceSize
    const end = Math.min(begin + sliceSize, bytesLength)

    const bytes = new Array(end - begin)
    for (let offset = begin, i = 0; offset < end; i += 1, offset += 1) {
      bytes[i] = byteCharacters[offset].charCodeAt(0)
    }

    byteArrays[sliceIndex] = new Uint8Array(bytes)
  }

  return new Blob(byteArrays, { type: contentType })
}
